
import { Component, Mixins, InjectReactive } from "vue-property-decorator";
import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import ETable from "@/components/ETable.vue";
import UploadImg from "@/components/uploadImg.vue";
import { tongueSubSymptomConfigSave, tongueSubSymptomConfigList, tongueSubSymptomAllList } from "@/api/tongue";

/**
 * 舌象配置组件
 * 提供舌象的增删改查功能
 */
@Component({ name: 'tongue-components-tongueAppearance',
    components: {
        ETable,
        UploadImg
    }
})
export default class TongueAppearance extends Mixins(Resize, TablePagination) {
    @InjectReactive() subTabActiveName!: string;
    // 查询表单
    queryForm = {
        exSymptomName: "",
        tongueColour: "",
        mossColor: "",
        tongueShaped: [],
        coatingNature: [],
        tongueSubDiagProject: ""
    }

    // 选项配置
    tongueColorOptions = [
        { label: '青紫舌', value: '青紫舌' },
        { label: '绛红舌', value: '绛红舌' },
        { label: '红舌', value: '红舌' },
        { label: '淡红舌', value: '淡红舌' },
        { label: '淡白舌', value: '淡白舌' }
    ]

    coatingColorOptions = [
        { label: '灰黑苔', value: '灰黑苔' },
        { label: '黄苔', value: '黄苔' },
        { label: '白苔', value: '白苔' },
        { label: '无苔', value: '无苔' }
    ]

    tongueShapeOptions = [
        { label: '光滑舌', value: '光滑舌' },
        { label: '娇嫩舌', value: '娇嫩舌' },
        { label: '苍老舌', value: '苍老舌' },
        { label: '裂纹舌', value: '裂纹舌' },
        { label: '瘦薄舌', value: '瘦薄舌' },
        { label: '舌尖点刺', value: '舌尖点刺' },
        { label: '舌边点刺', value: '舌边点刺' },
        { label: '齿痕舌', value: '齿痕舌' },
        { label: '胖大舌', value: '胖大舌' }
    ]

    coatingQualityOptions = [
        { label: '厚腻苔', value: '厚腻苔' },
        { label: '滑苔', value: '滑苔' },
        { label: '薄苔', value: '薄苔' },
        { label: '剥落苔', value: '剥落苔' }
    ]

    subtongueVeinOptions = [
        { label: '舌下络脉正常', value: '舌下络脉正常' },
        { label: '舌下络脉青紫曲张', value: '舌下络脉青紫曲张' }
    ]

    // 舌诊副症状选项
    subSymptomOptions: Array<any> = []

    // 表格数据
    tableData: Array<any> = []

    // 表格列配置
    columns = [
        { label: "ID", prop: "id" },
        { label: "舌诊副症状", prop: "exSymptomName" },
        { label: "舌色", prop: "tongueColour" },
        { label: "苔色", prop: "mossColor" },
        { label: "舌形", prop: "", formatter: (row) => { return row.tongueShaped.join(",") } },
        { label: "苔质", prop: "", formatter: (row) => { return row.coatingNature.join(",") } },
        { label: "舌下络脉", prop: "tongueSubDiagProject" },

        { label: "操作人", prop: "modifiedBy" },
        { label: "最后操作时间", prop: "modifiedTime" },
        { label: "操作", prop: "action", width: 120 },
    ]

    // Dialog相关状态
    dialogVisible = false
    dialogForm = {
        id: null,
        tongueExId: "", // 舌诊副症状
        tongueColour: "", // 舌色
        mossColor: "", // 苔色
        tongueShaped: [], // 舌形 (多选)
        coatingNature: [], // 苔质 (多选)
        tongueSubDiagProject: "" // 舌下络脉
    }

    // 表单验证规则
    dialogFormRules = {
        tongueExId: [
            { required: true, message: "请选择舌诊副症状", trigger: "change" }
        ],
        tongueColour: [
            { required: true, message: "请选择舌色", trigger: "change" }
        ],
        mossColor: [
            { required: true, message: "请选择苔色", trigger: "change" }
        ],
        tongueShaped: [
            { required: true, message: "请选择舌形", trigger: "change" },
            { type: 'array', min: 1, message: "至少选择一个舌形", trigger: "change" }
        ],
        coatingNature: [
            { required: true, message: "请选择苔质", trigger: "change" },
            { type: 'array', min: 1, message: "至少选择一个苔质", trigger: "change" }
        ]
        // tongueSubDiagProject 非必填，无需验证
    }

    // 加载状态
    searching = false
    saving = false

    mounted() {
        this.windowResize(310);
        this.getData();
        this.getSubSymptomOptions();
    }
    async getSubSymptomOptions() {
        try {
            // 获取舌诊副症状配置列表，根据创建时间倒序
            const res = await tongueSubSymptomAllList({});
            this.subSymptomOptions = res.data;;
        } catch (error) {
            console.error('获取舌诊副症状列表失败', error);
            this.$message.error('获取舌诊副症状列表失败');
        }
    }

    async getData() {
        try {
            tongueSubSymptomConfigList({
                ...this.queryForm, 
                pageNum: this.currentPage, 
                pageSize: this.pageSize
            }).then((res: any) => {
                this.tableData = res.data.list
                this.itemTotal = res.data.total
            })
        } catch (error) {
            console.error('获取数据失败', error)
            this.$message.error('获取数据失败')
        } finally {
            this.searching = false
        }
    }

    search() {
        this.resetPages()
        this.getData()
    }

    resetPages() {
        this.currentPage = 1;
        this.pageSize = 10;
    }

    add() {
        this.resetDialogForm()
        this.dialogVisible = true
    }

    edit(row: any) {
        this.resetDialogForm()
        this.dialogForm = {
            id: row.id,
            tongueExId: row.tongueExId || "",
            tongueColour: row.tongueColour || "",
            mossColor: row.mossColor || "",
            tongueShaped: row.tongueShaped || [],
            coatingNature: row.coatingNature || [],
            tongueSubDiagProject: row.tongueSubDiagProject || ""
        }
        this.dialogVisible = true
    }

    resetDialogForm() {
        this.dialogForm = {
            id: null,
            tongueExId: "",
            tongueColour: "",
            mossColor: "",
            tongueShaped: [],
            coatingNature: [],
            tongueSubDiagProject: ""
        }
        this.$nextTick(() => {
            (this.$refs.formRef as any)?.clearValidate()
        })
    }

    async deleteRow(row: any) {
        try {
            await this.$confirm('确定删除这条记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })

            // 这里应该调用实际的删除API
            // await deleteTongueAppearance({ id: row.id })

            this.$message.success('删除成功')
            this.getData()
        } catch (error) {
            if (error !== 'cancel') {
                console.error('删除失败', error)
                this.$message.error('删除失败')
            }
        }
    }

    handleClose() {
        this.cancel()
    }

    cancel() {
        this.dialogVisible = false
        this.resetDialogForm()
    }

    async save() {
        try {
            await (this.$refs.formRef as any).validate()
            tongueSubSymptomConfigSave({ ...this.dialogForm }).then(() => {
                this.$message.success("操作成功")
                this.dialogVisible = false
                this.getData()
            })
        } catch (error) {
            if (error !== 'cancel') {
                console.error('保存失败', error)
                this.$message.error('保存失败')
            }
        } finally {
            this.saving = false
        }
    }
}
